import Avatar from 'components/Avatar'
import ConstructionIcon from 'components/icons/ConstructionIcon'
import ContactIcon from 'components/icons/ContactIcon'
import DateRangeIcon from 'components/icons/DateRangeIcon'
import DomainIcon from 'components/icons/DomainIcon'
import InternetIcon from 'components/icons/InternetIcon'
import LocationIcon from 'components/icons/LocationIcon'
import {
  ApplySpan,
  BranchDiv,
  CompanyUrlDiv,
  ConnectSpan,
  CriteriaDiv,
  CriteriaFlex,
  DepartmentDiv,
  DescriptionList,
  DescriptionP,
  DescriptionPointsUl,
  DurationSpan,
  FreeCancelFlex,
  FullTimeDiv,
  FullTimeSpan,
  GroupFlex,
  GroupPepoleDiv,
  JobDescriptionDiv,
  JobLocationDiv,
  LocationConnectFlex,
  LocationFlex,
  LocationList,
  LocationSpan,
  LocationUl,
  PaymentsSpan,
  PeopleCountSpan,
  RoleDescription,
  RolesInfoFlex,
  RolesInformationDiv,
  SalaryInfoDiv,
  SocialMeadiaIconsFlex,
  TopSectionFlex,
} from 'modules/Roles/Partials/ViewIndividualRole/Components/Styles/Style'
import React from 'react'
import ReactPlayer from 'react-player'

const AboutUs = ({ roleData, corporateDetails }) => {
  const getSocilaMediaIcon = media => {
    if (media?.media == 'Facebook') {
      return 'https://pluginlive-public-assets.s3.ap-south-1.amazonaws.com/facebook.png'
    } else if (media?.media == 'Linkedin') {
      return 'https://pluginlive-public-assets.s3.ap-south-1.amazonaws.com/linkedin.png'
    }
    return 'https://pluginlive-public-assets.s3.ap-south-1.amazonaws.com/twitter.png'
  }

  return (
    <TopSectionFlex spaceBetween>
      <RolesInformationDiv>
        <RoleDescription>About Us</RoleDescription>
        <FullTimeDiv>
          <RolesInfoFlex>
            <GroupFlex centerVertically>
              <DomainIcon />
              <FullTimeSpan>{corporateDetails?.corporateType}</FullTimeSpan>
            </GroupFlex>
            <GroupPepoleDiv centerVertically>
              <ContactIcon />
              <PeopleCountSpan>
                {corporateDetails?.employeesNumber}
              </PeopleCountSpan>
            </GroupPepoleDiv>

            <FreeCancelFlex centerVertically>
              <DateRangeIcon />
              <ApplySpan>Since</ApplySpan>
              <DurationSpan>{corporateDetails?.establishedYear}</DurationSpan>
            </FreeCancelFlex>
          </RolesInfoFlex>
        </FullTimeDiv>
        <div>
          <JobDescriptionDiv>Description</JobDescriptionDiv>

          <DescriptionP
            dangerouslySetInnerHTML={{
              __html: corporateDetails?.longDescription,
            }}
          />
          <DescriptionP
            dangerouslySetInnerHTML={{
              __html: corporateDetails?.shortDescription,
            }}
          />

          <DescriptionPointsUl>
            <DescriptionList>
              Opportunity to make a positive impact
            </DescriptionList>
            <DescriptionList>Attractive salary & benefits</DescriptionList>
            <DescriptionList>
              Excellent career development opportunities
            </DescriptionList>
          </DescriptionPointsUl>
        </div>
        {corporateDetails?.corporateVideoLink && (
          <ReactPlayer
            controls
            width="682px"
            height="412px"
            url={corporateDetails?.corporateVideoLink}
          />
        )}
      </RolesInformationDiv>

      <SalaryInfoDiv>
        <LocationConnectFlex>
          <PaymentsSpan>
            <InternetIcon />
          </PaymentsSpan>
          <ConnectSpan>Connect</ConnectSpan>
        </LocationConnectFlex>
        <CompanyUrlDiv>{corporateDetails?.website}</CompanyUrlDiv>
        <SocialMeadiaIconsFlex>
          {corporateDetails?.socialMedia?.length
            ? corporateDetails?.socialMedia?.map((media, index) => (
                <a
                  href={media?.link}
                  target="_blank"
                  key={index + 'socialMedia'}
                  rel="noreferrer"
                >
                  <Avatar
                    background
                    src={getSocilaMediaIcon(media)}
                    size={25}
                    IconName={'I'}
                    font={18}
                  />
                </a>
              ))
            : null}
        </SocialMeadiaIconsFlex>
        <LocationFlex>
          <LocationSpan>
            <LocationIcon />
          </LocationSpan>
          <JobLocationDiv>Location</JobLocationDiv>
        </LocationFlex>
        <LocationUl>
          {corporateDetails?.branchLocation?.length
            ? corporateDetails?.branchLocation?.map(location => (
                <LocationList>
                  {location?.addressLine1}, {location?.addressLine2},
                  {location?.city},{location?.state}, {location?.country}{' '}
                </LocationList>
              ))
            : null}
        </LocationUl>

        <CriteriaFlex>
          <ConstructionIcon />
          <CriteriaDiv>Other Details</CriteriaDiv>
        </CriteriaFlex>
        <DepartmentDiv>Company Type</DepartmentDiv>
        <BranchDiv>{corporateDetails?.corporateType}</BranchDiv>
        <DepartmentDiv>Established in</DepartmentDiv>
        <BranchDiv>{corporateDetails?.establishedYear}</BranchDiv>
      </SalaryInfoDiv>
    </TopSectionFlex>
  )
}

export default AboutUs
